// extracted by mini-css-extract-plugin
export default {"container":"About_container__g4MLH"};